exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#data_sources .btn-success .simple-svg-wrapper {\n  display: inline;\n}\n#data_sources span.button-wrap .simple-svg {\n  top: -0.1rem;\n  position: relative;\n  margin-right: 0.8rem;\n  fill: #8ec24b !important;\n}\n#data_sources span.button-wrap:hover .simple-svg {\n  fill: white !important;\n}\n#data_sources .tooltip {\n  opacity: 1;\n}\n#data_sources .tooltip .tooltip-arrow {\n  border-bottom-color: #3b5870;\n}\n#data_sources .tooltip .tooltip-inner {\n  background: white;\n  padding: 0.8rem;\n  color: #58a4c8;\n  border: 0.16rem solid #ddd;\n  max-width: 25.6rem;\n}\n#data_sources .fa-info-circle {\n  color: #b2b2b2;\n}", ""]);

// exports
